import sidebarImage from '../../assets/images/sidebar.png'; // adjust relative path

export default function LoginLeftSide() {
  return (
    <div
      className="hidden md:flex w-1/2 bg-cover bg-center relative"
      style={{ backgroundImage: `url(${sidebarImage})`, borderRadius: 15 }}
    >
      <div className="absolute bottom-10 left-10 text-white font-acid font-[500] text-[40px] leading-[50px] tracking-[0.06em]">
        Dinero que fluye,
        <br />
        <span className="font-light italic">sin fronteras</span>
      </div>
    </div>
  );
}
